import { FilterSelect } from '@/shared/ui/FilterSelect';
import { EMPTY_PERIOD, type SchedulePeriod } from './api';

const TIME_OPTIONS = Array.from({ length: 18 }, (_, i) => {
  const value = `${String(i + 6).padStart(2, '0')}-00`;
  return { value, label: value };
});

type Props = {
  label: string;
  value: SchedulePeriod;
  disabled: boolean;
  onChange: (value: SchedulePeriod) => void;
};

/** "Не работаю" / "Работаю с … по …" / "Круглосуточно" editor for one schedule period. */
export const ScheduleField = ({ label, value, disabled, onChange }: Props) => {
  const isActive = Boolean(Number(value.is_active));
  const isAllDay = Boolean(Number(value.all_day));

  return (
    <div className="form-group">
      <label className="control-label">{label}</label>
      <div>
        <label style={{ fontWeight: 'normal', marginRight: 16 }}>
          <input
            type="radio"
            disabled={disabled}
            checked={!isActive}
            onChange={() => onChange(EMPTY_PERIOD)}
          />{' '}
          Не работаю
        </label>
        <label style={{ fontWeight: 'normal' }}>
          <input
            type="radio"
            disabled={disabled}
            checked={isActive}
            onChange={() => onChange({ ...value, is_active: 1 })}
          />{' '}
          Работаю
        </label>
      </div>
      {isActive && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '6px 0' }}>
            <FilterSelect
              options={TIME_OPTIONS}
              value={value.from ?? ''}
              width={100}
              placeholder="От"
              isDisabled={disabled}
              isClearable={false}
              onChange={(from) => onChange({ ...value, from, is_active: 1, all_day: 0 })}
            />
            —
            <FilterSelect
              options={TIME_OPTIONS}
              value={value.to ?? ''}
              width={100}
              placeholder="До"
              isDisabled={disabled}
              isClearable={false}
              onChange={(to) => onChange({ ...value, to, is_active: 1, all_day: 0 })}
            />
          </div>
          <label style={{ fontWeight: 'normal' }}>
            <input
              type="checkbox"
              disabled={disabled}
              checked={isAllDay}
              onChange={(e) => onChange({ ...value, all_day: e.target.checked ? 1 : 0, from: '', to: '' })}
            />{' '}
            Круглосуточно
          </label>
        </>
      )}
    </div>
  );
};
